var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2285 27C31.585 24.1472 33 20.4889 33 16.5C33 7.38733 25.6123 0 16.5 0C7.3877 0 0 7.38733 0 16.5C0 20.4889 1.41504 24.1472 3.77148 27H29.2285ZM8 15.5C8 10.8055 11.8057 7 16.5 7C16.7168 7 16.918 6.93091 17.082 6.8136C17.335 6.6322 17.5 6.33533 17.5 6C17.5 5.44775 17.0527 5 16.5 5C10.7012 5 6 9.70105 6 15.5C6 17.7643 6.71777 19.8638 7.93848 21.5796C8.25879 22.0297 8.88281 22.135 9.33301 21.8149C9.7832 21.4948 9.8877 20.8705 9.56836 20.4204C8.58008 19.032 8 17.3352 8 15.5ZM26.8037 14.9049C26.6221 14.6592 26.3301 14.5 26 14.5C25.4473 14.5 25 14.9478 25 15.5C25 17.3352 24.4199 19.032 23.4316 20.4204C23.1123 20.8705 23.2168 21.4948 23.667 21.8149C24.1172 22.135 24.7412 22.0297 25.0615 21.5796C26.2822 19.8638 27 17.7643 27 15.5C27 15.2771 26.9268 15.0712 26.8037 14.9049ZM17 19C18.6572 19 20 17.6569 20 16C20 15.4279 19.8398 14.8932 19.5615 14.4382L23.293 10.7072C23.6836 10.3167 23.6836 9.68347 23.293 9.29297C22.9023 8.90234 22.2695 8.90234 21.8789 9.29297L18.001 13.171C17.6875 13.0603 17.3506 13 17 13C15.3428 13 14 14.3431 14 16C14 17.6569 15.3428 19 17 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.d28108466a5f6591d6735a58f9bcc63d.svg";
export { ForwardRef as ReactComponent };